import { axios } from '@/utils/request'

const api = {
  enterprise: '/enterprise/contract'
}

export function updateContract (parameter) {
  return axios({
    url: api.enterprise + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function toMain (parameter) {
  return axios({
    url: api.enterprise + '/toMain',
    method: 'post',
    params: parameter
  })
}

export function toNonMain (parameter) {
  return axios({
    url: api.enterprise + '/toNonMain',
    method: 'post',
    params: parameter
  })
}

export function disable (parameter) {
  return axios({
    url: api.enterprise + '/disable',
    method: 'post',
    params: parameter
  })
}

export function enable (parameter) {
  return axios({
    url: api.enterprise + '/enable',
    method: 'post',
    params: parameter
  })
}

export function remove (parameter) {
  return axios({
    url: api.enterprise + '/remove',
    method: 'post',
    params: parameter
  })
}
